module.exports = __webpack_public_path__ + "img/attack.f2a79abd.png";